import { Flex } from "@chakra-ui/layout";

interface ContentRightItemProps {
  titulo: string;
  valor?: string;
}

export default function ContentRightItem({
  titulo,
  valor,
}: ContentRightItemProps) {
  return (
    <Flex mb="2">
      <Flex color="#768398" fontSize="12px" flex={4}>
        {titulo}
      </Flex>
      <Flex fontSize="12px" ml={20}>
        {valor}
      </Flex>
    </Flex>
  );
}
